
































import Vue from 'vue';
import Component from 'vue-class-component';

// Button types
import { ButtonOptions } from '@/components/input/types';

// Modal types
import { ModalType, InteractiveModalOptions } from '../types';

// The actual modal component
import Modal from '../Modal.vue';

// The content of the interactive modal
import InteractiveModalContent from './InteractiveContent.vue';

/**
 *  The base for a modal with interaction, asking a confirmal for example.
 */
@Component({
    components: {
        InteractiveModalContent,
    },
})
export default class InteractiveModalBase extends Vue {

    public $refs!: {
        modal: Modal;
    };

    /**
     *  The type of the modal, defaulting to `info`.
     */
    protected type: ModalType = ModalType.Info;

    /**
     *  The options for the modal.
     */
    protected options: InteractiveModalOptions | null  = null;

    /**
     *  The promise settler which should be awaited
     *  when invoking the `open()` method.
     */
    private settler!: (confirmed: boolean) => void;

    /**
     *  Used to get the details of the cancel button.
     */
    private get cancelButton(): ButtonOptions | null {

        return this.options?.cancel || null;

    }

    /**
     *  Used to get the details of the confirm button.
     */
    private get confirmButton(): ButtonOptions | null {

        return this.options?.confirm || null;

    }

    /**
     *
     *  Used to open the modal and await user action.
     *
     *  @param options The options of the interactive modal
     *
     *  @returns A promise which always resolves with
     *  either `true` (confirmed) or `false` (cancelled)
     *
     */
    public async open(options: InteractiveModalOptions): Promise<boolean> {

        return new Promise((resolve: (confirmed: boolean) => void) => {

            this.options = {
                ...this.options,
                ...options,
            };

            this.settler = resolve;

            this.$refs.modal.open();

        });

    }

    /**
     *
     *  Used to settle the promise and close the modal.
     *
     *  @param confirmed If the user confirmed
     *
     */
    private settle(confirmed: boolean): void {

        this.$refs.modal.close(true);

        this.settler(confirmed);

    }

}

